import Vue from 'vue'
import router from './router/index'
import store from './store'

import notification from 'ant-design-vue/es/notification'
import whiteList from './utils/whiteList'




router.beforeEach((to, from, next) => {
  // if (to.meta.title) {
  //   document.title = `${to.meta.title} - 授权系统`
  // }
  if (Vue.ls.get('token')) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (store.getters.role == '') {
        store.dispatch('GetUserInfo')
          .then(() => {
            const role = store.getters.role
            store.dispatch('GenerateRoutes', { role }).then(() => {
              router.addRoutes(store.getters.addRouters)
              if (['vip'].includes(role)) {
                next('/order-invoice-manage/invoice')
              } else if (['finance'].includes(role)) {
                next('/order-invoice-manage/invoiceList')
              } else {
                next()
              }
            })
          })
          .catch(() => {
            notification.error({
              message: '错误',
              description: '请求用户信息失败，请重试'
            })
            store.dispatch('Logout').then(() => {
              next({ path: '/login', query: { redirect: to.fullPath } })
            })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      next()
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  }
  next()
})

router.afterEach(() => {
})
